import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, Fragment, useRef } from "react";

import pages from "../../../constants/pages";
import AadharCardBack from ".././assests/AadharCard.svg";
import { useAlert, useAxiosV2, useAxios } from "../../../hooks";
import Form from "./Form";
import VerificationPopup from "../../user step components/VerificationPopup";
import { TextField } from "../../../components";
import { getVisitorFaceData } from "../../../utils/getVisitorFaceData";
import { HourglassEmpty } from "@mui/icons-material";

const MyComponent = ({
  visitorId,
  setVerification,
  OuterBox2,
  entityDetails,
  setIdentityType,
  OuterPaper,
  digipassDataKey,
  setVerificationFailedCount,
  documentsList,
  handleIdentityTypeChange,
  selectDocuments,
  setSelectDocuments,
  errorUrlS,
}) => {
  const axios = useAxios();

  const { alert } = useAlert();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);

  const digiLockerID = queryParams.get("id");
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [ocrLoading, setOCRLoading] = useState(false);

  const inputRef = useRef(null);
  const [CaptchaError, setCaptchaError] = useState(false);
  const [countryCode, setCountryCode] = useState([
    {
      _id: "29acaedf87bb4b94add8829dc7f5994c",
      name: "Afghanistan",
      code: "AF",
      dial_code: "+93",
    },
    {
      _id: "e1445f72fd834b168ba1954112798cda",
      name: "Albania",
      code: "AL",
      dial_code: "+355",
    },
    {
      _id: "f01f34e0b6ab4c6cb926b15abb26b8b9",
      name: "Algeria",
      code: "DZ",
      dial_code: "+213",
    },
    {
      _id: "5349edbf226a479ca02cf945998139b5",
      name: "Andorra",
      code: "AD",
      dial_code: "+376",
    },
    {
      _id: "8b2d841fb9484007893bdd8b789e196f",
      name: "Angola",
      code: "AO",
      dial_code: "+244",
    },
    {
      _id: "41fcb1d2ca5f435a9649193c127a0eeb",
      name: "Argentina",
      code: "AR",
      dial_code: "+54",
    },
    {
      _id: "dbec9a97f3df4d7eb7b5044484d89105",
      name: "Australia",
      code: "AU",
      dial_code: "+61",
    },
    {
      _id: "c152f6272d3d4aed887560706796087a",
      name: "Austria",
      code: "AT",
      dial_code: "+43",
    },
    {
      _id: "7b7f842ca75a4158ad22842bcc2db207",
      name: "Bangladesh",
      code: "BD",
      dial_code: "+880",
    },
    {
      _id: "9c916e2c1f96472586f9f61a0391be08",
      name: "Belgium",
      code: "BE",
      dial_code: "+32",
    },
    {
      _id: "12962790155c403ba077646e67ba4d12",
      name: "Brazil",
      code: "BR",
      dial_code: "+55",
    },
    {
      _id: "a46552ddc58442af8a86491aa574c552",
      name: "Canada",
      code: "CA",
      dial_code: "+1",
    },
    {
      _id: "5c0c2eaf5b92442bb6d2c3353080d57a",
      name: "China",
      code: "CN",
      dial_code: "+86",
    },
    {
      _id: "cd4c448bb1cb453fb61f2d81001312c6",
      name: "Denmark",
      code: "DK",
      dial_code: "+45",
    },
    {
      _id: "e4faa67304f644d49cdd2b4b16308f86",
      name: "Egypt",
      code: "EG",
      dial_code: "+20",
    },
    {
      _id: "d92cb6f25130427aacd18bcf72991e3a",
      name: "Finland",
      code: "FI",
      dial_code: "+358",
    },
    {
      _id: "beb1cb2e57214df1b5b962efca088233",
      name: "France",
      code: "FR",
      dial_code: "+33",
    },
    {
      _id: "c02b9ca0a5f041a3b0ce0ba49522065d",
      name: "Germany",
      code: "DE",
      dial_code: "+49",
    },
    {
      _id: "8249c6d128494fe68ffd1459db32f114",
      name: "India",
      code: "IN",
      dial_code: "+91",
    },
    {
      _id: "96d34444f232469ba4c6c4a35d8aa35b",
      name: "United States",
      code: "US",
      dial_code: "+1",
    },
  ]);
  const [open, setOpen] = useState(false);
  const [errorStep, setErrorStep] = useState(null);
  const [stopStep, setStopStep] = useState(6);
  const [errorUrl, setErrorUrl] = useState(errorUrlS || "");
  const [errorMsg, setErrorMsg] = useState(null);
  const [formData, setFormData] = useState({
    passport_Card: "",
    dob: "",
    captchaInput: "",
  });

  const entityId = queryParams.get("entity_id");
  const bookingId = queryParams.get("booking_id");
  const autoConsent = queryParams.get("auto_consent");
  const userTypeID = queryParams.get("user_type_id");
  const docFace = queryParams.get("doc_face");
  const indepentent = queryParams.get("indepentent");

  const validationSchema = Yup.object().shape({
    captchaInput: Yup.string()
      .required("Captcha is required")
      .test("captcha-match", "Captcha does not match", function (value) {
        return value === captcha;
      }),

    countryCode: Yup.string().required("Country code is required"),

    passportCardData: Yup.mixed()
      .required("Passport Card file is required")
      .test("fileSize", "File too large", (value) => value),

    passport_Card: Yup.string().required("Passport Card name is required"),
  });

  useEffect(() => {
    axios({
      url: "event/govt-api/get-passport-country",
      method: "GET",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setCountryCode(response.data);
      }
    });
  }, []);

  const adjustColor = (hex) => {
    if (!hex) return "#c4c412";

    // Remove '#' if present
    hex = hex.replace("#", "");

    // Convert shorthand hex (like #fc0)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Check brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // If too bright, darken it
    if (brightness > 180) {
      const darken = (val) => Math.max(0, val - 60);
      return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
    }

    return `#${hex}`;
  };

  return (
    <Fragment>
      <Grid item container>
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <div
                  style={{
                    width: "100%",
                    position: "relative",
                    height: "35vh",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      position: "relative",
                      zIndex: "999999",
                      top: "47%",
                      left: "2%",
                      width: "96.25%",
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={900}
                      sx={{ marginTop: "7.5px" }}
                    >
                      {"Verify Profile Using Passport"}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{ marginTop: "7.5px", color: "#00000099" }}
                    >
                      {/* {"Please Enter your Passport"} */}
                      {`Please enter your Passport to verify your profile.`}
                    </Typography>

                    <TextField
                      select
                      size="small"
                      style={{ marginTop: "10px", background: "white" }}
                      value={selectDocuments}
                      onChange={(e) => {
                        setSelectDocuments(e.target.value);
                        handleIdentityTypeChange(e.target.value);
                      }}
                    >
                      {documentsList?.map((item, index) => (
                        <MenuItem key={item.id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    {documentsList?.filter((item) => item?.document_id == 4)[0]
                      ?.display && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.2,
                          backgroundColor: documentsList?.filter(
                            (item) => item?.document_id == 4
                          )[0]?.color,
                          color: "#060606ff", // dark gold text
                          padding: "8px 14px",
                          borderRadius: "4px",
                          borderLeft: `4px solid ${adjustColor(
                            documentsList?.filter(
                              (item) => item?.document_id == 4
                            )[0]?.color
                          )}`, // light yellow left bar
                          width: "fit-content",
                          boxShadow: `0 0 0 1px ${
                            documentsList?.filter(
                              (item) => item?.document_id == 4
                            )[0]?.color
                          } inset`, // subtle border like in screenshot
                        }}
                      >
                        <HourglassEmpty sx={{ fontSize: 18 }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          {
                            documentsList?.filter(
                              (item) => item?.document_id == 4
                            )[0]?.message_note
                          }
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                  <img
                    style={{
                      height: "35vh",
                      position: "absolute",
                      top: "0px",
                    }}
                    src={AadharCardBack}
                  />
                </div>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        container
        mt={
          documentsList?.filter((item) => item?.document_id == 4)[0]?.display
            ? 7.5
            : 0
        }
      >
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2 style={{ width: "100%" }}>
              <OuterPaper
                style={{
                  padding: "15px 15px",
                  "@media (max-width: 370px)": {
                    marginTop: "15px",
                  },
                }}
                elevation={3}
              >
                <Formik
                  initialValues={formData}
                  validationSchema={validationSchema}
                  onSubmit={(formData) => {
                    try {
                      if (formData.captchaInput !== captcha) {
                        setCaptchaError(true);
                        return;
                      }
                      setLoading(true);
                      let faceData = digipassDataKey.filter((item) => {
                        return localStorage.getItem(item);
                      });
                      axios({
                        url:
                          "/event/govt-api/passport-details?country_code=" +
                          formData.countryCode,
                        method: "POST",
                        data: {
                          passport_img: formData.passportCardData,
                          ...{
                            ...(!bookingId && {
                              booking_id:
                                bookingId ||
                                sessionStorage.getItem("bookingId"),
                            }),
                          },
                          name: " ",
                          visitor_id: visitorId,
                          face_data: localStorage.getItem(faceData[0]),
                          document_verification: true,
                          is_encrypted_face: true,
                          phone_number:
                            visitorData.phoneNumber ||
                            sessionStorage.getItem("mobileNumber"),
                          booking_id: bookingId,
                          entity_id: entityId,
                          user_type_id: userTypeID,
                          auto_consent: autoConsent,
                        },
                        disableRedirect: true,
                      }).then((response) => {
                        if (response.status) {
                          if (autoConsent == "true") {
                            setStopStep(5);
                            axios({
                              url: "event/visitor/save-consent",
                              method: "POST",
                              data: {
                                visitor_id: visitorId,
                                booking_id: bookingId,
                                entity_id: entityId,
                                user_type_id: userTypeID,
                                face_data: response.data.encrypted_face_data,
                                consent_for: ["face", "contact-details"],
                              },
                              disableRedirect: true,
                            }).then((resp) => {
                              if (resp.status) {
                                setStopStep(6);
                                setOpen(true);
                              }
                            });
                          } else {
                            setOpen(true);
                          }
                          let key = visitorId;
                          localStorage.setItem(
                            key,
                            response.data.encrypted_face_data
                          );
                        } else {
                          setLoading(false);
                          if (response.data.step) {
                            setOpen(true);
                            setErrorStep(response.data.step);
                            setErrorUrl(response.data.next_url);
                            setErrorMsg(response.displayMessage);
                          }
                        }
                        setVerificationFailedCount(
                          (prevCount) => prevCount + 1
                        );
                      });
                    } catch (error) {
                      setLoading(false);
                      setVerificationFailedCount((prevCount) => prevCount + 1);
                      dispatch(
                        alert({
                          type: "error",
                          message: error,
                        })
                      );
                    }
                  }}
                >
                  {(formikProps) => {
                    return (
                      <Fragment>
                        <Form
                          captcha={captcha}
                          loading={loading}
                          errorUrl={errorUrl}
                          ocrLoading={ocrLoading}
                          formikProps={formikProps}
                          countryCode={countryCode}
                          documentsList={documentsList}
                          setCaptcha={setCaptcha}
                          setVerification={setVerification}
                          setIdentityType={setIdentityType}
                        />
                      </Fragment>
                    );
                  }}
                </Formik>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <VerificationPopup
        open={open}
        startStep={0}
        errorStep={errorStep}
        errorMsg={errorMsg}
        onClose={() => {
          setOpen(false);
          setErrorStep(null);
          !digiLockerID && setErrorUrl("");
          setStopStep(6);

          if (errorStep != null) {
            navigate(errorUrl);
          } else if (bookingId == -1 && docFace == "true") {
            navigate(
              `${pages.EventSuccess.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}`
            );
          } else if (bookingId == -1) {
            navigate(pages.Profile.route);
          } else {
            if (bookingId == -1) {
              navigate(pages.Profile.route);
            }

            if (userTypeID == 1) {
              navigate(
                `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (
              userTypeID == 3 ||
              userTypeID == 4 ||
              userTypeID == 6 ||
              userTypeID == 8
            ) {
              navigate(
                `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (userTypeID == 2) {
              navigate(
                `${
                  indepentent
                    ? pages.IndependentAppointmentSummary.route
                    : pages.AppointmentSummary.route
                }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            } else if (userTypeID == 5) {
              navigate(
                `${pages.HotelSummary.path}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`
              );
            }
          }
        }}
      />
    </Fragment>
  );
};

export default MyComponent;
